"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeDeep = exports.getNested = exports.initials = exports.plural = exports.reduce = exports.Json = void 0;
var Json;
(function (Json) {
    function stringify(json, force) {
        try {
            if (force && typeof json === 'string')
                return json;
            return JSON.stringify(json);
        }
        catch (error) {
        }
    }
    Json.stringify = stringify;
    function parse(jsonText) {
        try {
            if (typeof jsonText === 'object')
                return jsonText;
            return JSON.parse(jsonText);
        }
        catch (error) {
        }
    }
    Json.parse = parse;
})(Json = exports.Json || (exports.Json = {}));
function reduce(object, target, exclude) {
    if (exclude) {
        let obj = {};
        const keys = Object.keys(object).filter(x => x.startsWith(`${target}_`));
        for (let key of keys) {
            obj[key.delete(`${target}_`)] = object[key];
        }
        return obj;
    }
    else {
        object[target] = {};
        const keys = Object.keys(object).filter(x => x.startsWith(`${target}_`));
        for (let key of keys) {
            object[target][key.delete(`${target}_`)] = object[key];
            delete object[key];
        }
        return object;
    }
}
exports.reduce = reduce;
function plural(value, single, plural) {
    if (plural)
        return value > 1 ? plural : single;
    else
        return value > 1 ? `${single}s` : single;
}
exports.plural = plural;
function initials(name, lastname) {
    if (name && lastname) {
        return (name.substring(0, 1) + lastname.substring(0, 1)).toUpperCase();
    }
    else if (name.split(' ').length > 1) {
        return (name.split(' ')[0].substring(0, 1) + name.split(' ')[0].substring(0, 1)).toUpperCase();
    }
    else if (name) {
        return name.substring(0, 1).toUpperCase();
    }
    else if (lastname) {
        return lastname.substring(0, 1).toUpperCase();
    }
}
exports.initials = initials;
function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}
function getNested(key, item) {
    if (typeof key === 'string') {
        const value = key.split('.').reduce((obj, key) => obj[key], item);
        if (value) {
            return String(value);
        }
        return '';
    }
    else if (Array.isArray(key)) {
        const value = key.map(k => k.split('.').reduce((obj, key) => obj[key], item));
        if (value) {
            return String(value);
        }
        return [];
    }
}
exports.getNested = getNested;
function mergeDeep(target, ...sources) {
    if (!sources.length)
        return target;
    const source = sources.shift();
    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key])
                    Object.assign(target, { [key]: {} });
                mergeDeep(target[key], source[key]);
            }
            else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }
    return mergeDeep(target, ...sources);
}
exports.mergeDeep = mergeDeep;
